// extracted by mini-css-extract-plugin
export default {"iconDiv":"number-item_iconDiv__2gKnl","wrapperDiv":"number-item_wrapperDiv__pN4cp","selectedIconDiv":"number-item_selectedIconDiv__ESlY3"};